import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  client: {
    NEXT_PUBLIC_AMPLITUDE_KEY: z.string(),
    NEXT_PUBLIC_CDN_BASE_URL: z.string().url(),
    NEXT_PUBLIC_FLOUNDER_KEY: z.string(),
    NEXT_PUBLIC_HACKLE_SDK_KEY: z.string(),
    NEXT_PUBLIC_NBC_API_URL: z.string().url(),
    NEXT_PUBLIC_ONLINE_API_URL: z.string().url(),
    NEXT_PUBLIC_ONLINE_URL: z.string().url(),
    NEXT_PUBLIC_PAGE_URL: z.string().url(),
    NEXT_PUBLIC_SERVER: z.string().url(),
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: z.string(),
    NEXT_PUBLIC_WHATTIME_TOKEN: z.string(),
    NEXT_PUBLIC_ENV: z.enum(['PRODUCTION', 'STAGING', 'DEVELOPMENT']),
    NEXT_PUBLIC_DATADOG_APPLICATION_ID: z.string(),
    NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: z.string(),
    NEXT_PUBLIC_DATADOG_SESSION_RATE: z.coerce.number().default(0),
    NEXT_PUBLIC_DATADOG_SESSION_REPLAY_RATE: z.coerce.number().default(0),
    NEXT_PUBLIC_KAKAO_API_KEY: z.string(),
    NEXT_PUBLIC_SCC_URL: z.string().url(),
  },
  server: {
    AWS_S3_REGION_NAME: z.string(),
    AWS_STORAGE_CDN_BUCKET: z.string(),
    AWS_ACCESS_KEY_ID: z.string(),
    AWS_SECRET_ACCESS_KEY: z.string(),
    CALENDLY_TOKEN: z.string(),
    CALENDLY_API_BASE_URL: z.string().url(),
    CALENDLY_ORGANIZATION_URI: z.string().url(),
  },
  runtimeEnv: {
    CALENDLY_TOKEN: process.env.CALENDLY_TOKEN,
    CALENDLY_API_BASE_URL: process.env.CALENDLY_API_BASE_URL,
    CALENDLY_ORGANIZATION_URI: process.env.CALENDLY_ORGANIZATION_URI,
    AWS_S3_REGION_NAME: process.env.AWS_S3_REGION_NAME,
    AWS_STORAGE_CDN_BUCKET: process.env.AWS_STORAGE_CDN_BUCKET,
    AWS_ACCESS_KEY_ID: process.env.AWS_ACCESS_KEY_ID,
    AWS_SECRET_ACCESS_KEY: process.env.AWS_SECRET_ACCESS_KEY,
    NEXT_PUBLIC_AMPLITUDE_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_KEY,
    NEXT_PUBLIC_CDN_BASE_URL: process.env.NEXT_PUBLIC_CDN_BASE_URL,
    NEXT_PUBLIC_FLOUNDER_KEY: process.env.NEXT_PUBLIC_FLOUNDER_KEY,
    NEXT_PUBLIC_HACKLE_SDK_KEY: process.env.NEXT_PUBLIC_HACKLE_SDK_KEY,
    NEXT_PUBLIC_NBC_API_URL: process.env.NEXT_PUBLIC_NBC_API_URL,
    NEXT_PUBLIC_ONLINE_API_URL: process.env.NEXT_PUBLIC_ONLINE_API_URL,
    NEXT_PUBLIC_ONLINE_URL: process.env.NEXT_PUBLIC_ONLINE_URL,
    NEXT_PUBLIC_PAGE_URL: process.env.NEXT_PUBLIC_PAGE_URL,
    NEXT_PUBLIC_SERVER: process.env.NEXT_PUBLIC_SERVER,
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
    NEXT_PUBLIC_WHATTIME_TOKEN: process.env.NEXT_PUBLIC_WHATTIME_TOKEN,
    NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
    NEXT_PUBLIC_DATADOG_APPLICATION_ID:
      process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    NEXT_PUBLIC_DATADOG_CLIENT_TOKEN:
      process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    NEXT_PUBLIC_DATADOG_SESSION_RATE:
      process.env.NEXT_PUBLIC_DATADOG_SESSION_RATE,
    NEXT_PUBLIC_DATADOG_SESSION_REPLAY_RATE:
      process.env.NEXT_PUBLIC_DATADOG_SESSION_REPLAY_RATE,
    NEXT_PUBLIC_KAKAO_API_KEY: process.env.NEXT_PUBLIC_KAKAO_API_KEY,
    NEXT_PUBLIC_SCC_URL: process.env.NEXT_PUBLIC_SCC_URL,
  },
  skipValidation: process.env.NODE_ENV === 'test',
});
